import "./PageLoader.css";

export default function PageLoader({
  text = "در حال بارگذاری...",
}) {
  return (
    <div className="page-loader">
      <div className="page-loader-content">

        <div className="page-loader-spinner">
          <span />
        </div>

        <p>{text}</p>

      </div>
    </div>
  );
}